<ng-container *ngIf="getValidationError() as errorMessage">
    {{errorMessage}}
</ng-container>
